import React from "react";
import { appHost } from "../../helpers/uri";

const PrintSlip = ({ v }) => {
  const _show = () => {
    window.open(`${appHost}/print/${v?._id}`, `Print Application Slip`, `_parent`, `width=450,height=650`);
  };
  return (
    <button disabled={!v.verified ? true : false} onClick={_show} className="btn btn-info text-white float-right">
      Print Application Slip <i className="fa-solid fa-print"></i>
    </button>
  );
};

export default PrintSlip;
